export default __webpack_public_path__ + "static/media/signature@2x.52fc643a.webp";